export default function Dimensions()
{
  const getViewport = (win = window) =>
  {
    const scrollTop = BEditor.window.getScrollTop(win),
          scrollLeft = BEditor.window.getScrollLeft(win);

    return (win.document.compatMode === 'BackCompat') ?
      { width: win.document.body.clientWidth, height: win.document.body.clientHeight, scrollTop: scrollTop, scrollLeft: scrollLeft } :
      { width: win.document.documentElement.clientWidth, height: win.document.documentElement.clientHeight, scrollTop: scrollTop, scrollLeft: scrollLeft };
  };


  this.getXY = (element, container = null) =>
  {
    if (!element) { return { x: 0, y: 0, root: null }; }

    let x = element.offsetLeft || 0,
        y = element.offsetTop || 0,
        parentElement = element.offsetParent,
        root = element;

    while (parentElement && parentElement !== container)
    {
      x += parentElement.offsetLeft;
      y += parentElement.offsetTop;

      root = parentElement;
      parentElement = parentElement.offsetParent;
    }

    element.X = x;
    element.Y = y;

    return { x: x, y: y, root: root };
  };


  this.getElementXY = (element, win = window, args = {}) =>
  {
    if (!element)
    {
      return ({ 'X': 0, 'Y': 0, 'left': 0, 'top': 0, 'right': 0, 'bottom': 0, 'width': 0, 'height': 0, 'deltaScrollX': 0, 'deltaScrollY': 0 });
    }

    const container = args.container || null,
          isBody = (element.nodeName.toUpperCase() === 'BODY'),
          offsetXY = this.getXY(element, container),
          x = offsetXY.x,
          y = offsetXY.y,
          width = isBody ? BEditor.window.getInnerWidth(win) + BEditor.window.getScrollBarWidth() : element.offsetWidth,
          height = isBody ? BEditor.window.getInnerHeight(win) + BEditor.window.getScrollBarWidth() : element.offsetHeight;

    element.X = x;
    element.Y = y;

    return {
      'X': x,
      'Y': y,
      'left': x,
      'top': y,
      'right': x + width,
      'bottom': y + height,
      'width': width,
      'height': height,
      'deltaScrollX': x - (container ? container.scrollLeft : BEditor.window.getScrollLeft(win)),
      'deltaScrollY': y - (container ? container.scrollTop : BEditor.window.getScrollTop(win))
    };
  };


  this.getElementAbsXY = (elem, win) =>
  {
    const lc = this.getElementXY(elem, win);
    let fr, fc;

    lc.viewport = getViewport(BEditor.environment.topWindow);

    while (win && win !== win.parent)
    {
      fr = BEditor.utils.getFrameByWindow(win);

      if (fr != null)
      {
        fc = this.getElementXY(fr, win.parent);
      }

      if (fc)
      {
        lc.X += fc.X;
        lc.Y += fc.Y;
        lc.left += fc.left;
        lc.right += fc.left;
        lc.top += fc.top;
        lc.bottom += fc.top;
        lc.deltaScrollX += fc.deltaScrollX;
        lc.deltaScrollY += fc.deltaScrollY;
      }

      win = win.parent;
    }

    return lc;
  };


  this.getElementBox = (element, win = window) =>
  {
    const styleAttrs =
          [
            'marginLeft', 'marginRight', 'marginTop', 'marginBottom',
            'borderLeftWidth', 'borderRightWidth', 'borderTopWidth', 'borderBottomWidth',
            'paddingLeft', 'paddingRight',  'paddingTop',  'paddingBottom',
            'width', 'height'
          ],
          box = BEditor.styleHelpers.getElementStyles(element, styleAttrs, win, true);

    let offsetWidth,
        offsetHeight;

    box.deltaLeft = box.marginLeft + box.borderLeftWidth + box.paddingLeft;
    box.deltaInnerLeft = box.borderLeftWidth + box.paddingLeft;
    box.deltaRight = box.marginRight + box.borderRightWidth + box.paddingRight;
    box.deltaInnerRight = box.borderRightWidth + box.paddingRight;
    box.deltaTop = box.marginTop + box.borderTopWidth + box.paddingTop;
    box.deltaInnerTop = box.borderTopWidth + box.paddingTop;
    box.deltaBottom = box.marginBottom + box.borderBottomWidth + box.paddingBottom;
    box.deltaInnerBottom = box.borderBottomWidth + box.paddingBottom;
    box.deltaWidth = box.deltaLeft + box.deltaRight;
    box.deltaInnerWidth = box.deltaInnerLeft + box.deltaInnerRight;
    box.deltaHeight = box.deltaTop + box.deltaBottom;
    box.deltaInnerHeight = box.deltaInnerTop + box.deltaInnerBottom;
    box.realWidth = box.width + box.marginLeft + box.marginRight;
    box.realHeight = box.height + box.marginTop + box.marginBottom;

    if (element)
    {
      offsetWidth = element.offsetWidth;
      offsetHeight = element.offsetHeight;

      box.scrollWidth = element.scrollWidth;
      box.scrollHeight = element.scrollHeight;
      box.offsetWidth = offsetWidth;
      box.offsetHeight = offsetHeight;
      box.innerOffsetWidth = offsetWidth - box.deltaInnerWidth;
      box.innerOffsetHeight = offsetHeight - box.deltaInnerHeight;
      box.realOffsetWidth = offsetWidth + box.marginLeft + box.marginRight;
      box.realOffsetHeight = offsetHeight + box.marginTop + box.marginBottom;
    }
    else
    {
      box.scrollWidth = 0;
      box.scrollHeight = 0;
      box.offsetWidth = 0;
      box.offsetHeight = 0;
      box.innerOffsetWidth = 0;
      box.innerOffsetHeight = 0;
      box.realOffsetWidth = 0;
      box.realOffsetHeight = 0;
    }

    return box;
  };


  this.getElementRect = (element, win = window) =>
  {
    let left, right, top, bottom, height, width, heightCenter, widthCenter,
        viewport = getViewport(win),
        scrollTop = viewport.scrollTop,
        scrollLeft = viewport.scrollLeft,
        tmp,
        rect,
        offset,
        x,
        y;

    if (element.getBoundingClientRect)
    {
      if (typeof(this.getElementRect.offset) !== 'number')
      {
        tmp = win.document.createElement('div');
        tmp.style.cssText = 'position:absolute;left:0;top:0;';
        win.document.body.appendChild(tmp);
        this.getElementRect.offset = -tmp.getBoundingClientRect().top - scrollTop;
        win.document.body.removeChild(tmp);
        tmp = null;
      }

      try
      {
        rect = element.getBoundingClientRect();
      }
      catch(ex) { rect = [0,0]; } // IE fix

      offset = this.getElementRect.offset;

      left = rect.left + offset + scrollLeft;
      right = rect.right + offset + scrollLeft;
      top = rect.top + offset + scrollTop;
      bottom = rect.bottom + offset + scrollTop;
      height = bottom - top;
      width = right - left;
      heightCenter = top + (height >> 1);
      widthCenter = left + (width >> 1);

      return {
        left: left,
        right: right,
        top: top,
        bottom: bottom,
        height: height,
        width: width,
        heightCenter: heightCenter,
        widthCenter: widthCenter,
        viewport: viewport
      };

    }
    else
    {

      offset = this.getXY(element);
      x = offset.x;
      y = offset.y;

      left = x - scrollLeft;
      right = x + element.offsetWidth - scrollLeft;
      top = y - scrollTop;
      bottom = y + element.offsetHeight - scrollTop;
      height = bottom - top;
      width = right - left;
      heightCenter = top + (height >> 1);
      widthCenter = left + (width >> 1);


      return {
        left: left,
        right: right,
        top: top,
        bottom: bottom,
        height: height,
        width: width,
        heightCenter: heightCenter,
        widthCenter: widthCenter,
        viewport: viewport
      };
    }
  };


  this.getElementScreenXY = (element, win = window, args = {}) =>
  {
    let isBody, width, height,
        container = args.container || null,
        offsetXY = this.getXY(element, container),
        x = offsetXY.x - offsetXY.root.scrollLeft,
        y = offsetXY.y - offsetXY.root.scrollTop;

    offsetXY = null;

    element.X = x;
    element.Y = y;
    isBody = (element.nodeName.toUpperCase() === 'BODY');
    width = isBody ? BEditor.window.getInnerWidth(win) + BEditor.window.getScrollBarWidth() : element.offsetWidth;
    height = isBody ? BEditor.window.getInnerHeight(win) + BEditor.window.getScrollBarWidth() : element.offsetHeight;

    return { X: x, Y: y, left: x, top: y, right: x + width, bottom: y + height, width: width, height: height };
  };
}
